import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { Toast } from '@tcc/crate';

import { messageTypes } from 'constants/values';

const toastTypeLookup = {
  'SUCCESS': Toast.SUCCESS,
  'ERROR': Toast.WARNING,
  'NEUTRAL': Toast.NEUTRAL,
  'SYSTEM_ERROR': Toast.ERROR,
  'MODAL': null
};

const Message = ({
  buttons=[],
  id,
  index,
  onClose,
  showDismiss=true,
  text,
  testId,
  title,
  toast=false,
  type
}) => {
  const handleDismiss = showDismiss ? () => { onClose(id); } : null;

  return (
    <Toast
      autoDismiss={type === Toast.SUCCESS}
      dismissHandler={handleDismiss}
      id={id}
      isVisible={toast}
      key={id}
      primaryActionHandler={get(buttons[0], 'onClick')}
      primaryActionText={get(buttons[0], 'text')}
      secondaryActionHandler={get(buttons[1], 'onClick')}
      secondaryActionText={get(buttons[1], 'text')}
      extraPrimaryActionHandler={get(buttons[2], 'onClick')}
      extraPrimaryActionText={get(buttons[2], 'text')}
      testId={`toast-${testId || index}`}
      text={text}
      title={title}
      type={toastTypeLookup[type]}
    />
  );
};

Message.propTypes = {
  buttons: PropTypes.array,
  id: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  showDismiss: PropTypes.bool,
  testId: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string.isRequired,
  toast: PropTypes.bool,
  type: PropTypes.oneOf(Object.keys(messageTypes)).isRequired
};

export default Message;
